export default {
    padding: 0.5,
    line: {
        width: 2,
        height: 0.25,
        spacing: 0.3,
        radius: 0.25,
    },
};
